import React from "react";
import { IoCloseSharp, IoTrash } from "react-icons/io5";
import { formatToINR, getFileUrl } from "../../../utils/helper";
import { useDispatch } from "react-redux";
import { addToCart, removeFromCart } from "../../../store/slice/userActions";
import placeHolderImage from "../../../assets/placeholder/product.jpg";
import Button from "../../ui/utils/Button";
import { FiMinus, FiPlus } from "react-icons/fi";
const CartItem = ({ item,className }) => {
  const dispatch = useDispatch();

  const mainImage =
    item?.product?.image ??
    placeHolderImage;

  const handleRemove = () => {
    dispatch(removeFromCart(item?.product?._id));
  };
  const increaseQuantity = async (productId) => {
    await dispatch(addToCart({ productId, quantity: 1, type: "I" })).unwrap();
  };

  const decreaseQuantity = async (productId) => {
    await dispatch(addToCart({ productId, quantity: 1, type: "D" })).unwrap();
  };


  return (
    <div className={`py-2 ${className} my-2 border-b rounded-md  hover:bg-gray-50`}>
      <div className="flex items-center justify-between px-2 ">
        <div className="flex items-center gap-2">
          <img
            src={getFileUrl(mainImage)}
            height={50}
            width={50}
            alt={item?.product?.name}
            className="border"
          />
          <div className="flex flex-col gap-1">
            <p className="font-[450]   justify-self-start">
              {item?.product?.name}
            </p>
            <p className="text-gray-500">
              {`${item.quantity}  * ${formatToINR(
                item?.product?.finalPrice.toFixed(2)
              )}`}
              <span className="font-semibold"></span>
            </p>
          </div>
        </div>
          <div className=" flex items-end flex-col gap-1">
             <button className="bg-red-100 hover:text-white hover:bg-red-500 p-2 rounded-full">
          <IoTrash
            className="text-lg text-red-500 hover:text-white cursor-pointer"
            onClick={handleRemove}
          />
        </button>
        <div className="flex items-center justify-center gap-2">
          <button
            onClick={() =>
              decreaseQuantity(item?.product._id)
            }
            className="p-1 text-gray-600 border rounded hover:bg-gray-100"
          >
            <FiMinus size={14} />
          </button>
          <span>{item.quantity}</span>
          <button
            onClick={() =>
              increaseQuantity(item?.product._id)
            }
            className="p-1 text-gray-600 border rounded hover:bg-gray-100"
          >
            <FiPlus size={14} />
          </button>
        </div>
          </div>
     
      </div>
    </div>
  );
};

export default CartItem;
